import axios from "../../axios";

const callback = async function (accessToken,uuid = {}) {
    try {
        const response = await axios.get('admin/pay-out/callback',{
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default callback;
